import React from 'react';

interface PrimaryButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  children,
  className = '',
  ...props
}) => {
  return (
    <button
      className={`px-4 py-2 bg-slate-800 hover:bg-slate-700 text-white rounded-md text-sm transition-colors ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default PrimaryButton;
